import yellowRound from '@assets/icons/100x100/yellowRound.png';
import { Box } from '@chakra-ui/react';
import { useMouseFocus } from '@hooks/useMouseFocus';

export default function MouseFocus() {
  const { isDisplayed } = useMouseFocus();

  if (!isDisplayed) {
    return;
  }

  return (
    <Box
      position="absolute"
      width="100%"
      height="100%"
      border="8px solid"
      borderColor="yellow.500"
      zIndex={6000}
      opacity={0.85}
      style={{ cursor: `url('${yellowRound}') 50 50, auto` }}
    />
  );
}
